export default __webpack_public_path__ + "Src/Client/MainPage/mainPage.html";